﻿export class SecondaryNavigation {

    public static getPageTitle($: JQueryStatic): void {        
        const pageHeader = $("#pageH1Header");
        const secondaryNavTitle = $(".secondaryNav-widget .attrax-page-title");
        secondaryNavTitle.text(pageHeader.text());
    }   
    public static injectOpenButton($: JQueryStatic): void {
        $(".secondaryNav-widget").append("<p class='secondaryNav-widget__btn'></p>");
    }   
    public static openSecondaryNav($: JQueryStatic): void {
        const secondaryNav = $(".secondaryNav-widget");        
        const secondaryNavList = $(".secondaryNav-widget .navRoot");
        const secondaryNavBtn = $(".secondaryNav-widget__btn");
        const contentPageHeading = $('.content-page__heading');
        secondaryNavBtn.on("click", function () {
            secondaryNav.toggleClass("secondaryNav-widget--open");
            secondaryNavList.slideToggle("fast");

            if (!contentPageHeading.hasClass('hide')) {
                setTimeout(function () {
                    contentPageHeading.addClass('hide');

                }, 200);
            } else {
                contentPageHeading.removeClass('hide');

            }

        });
    }
}
